"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebLogger = void 0;
const configs_1 = require("./configs");
const file_store_1 = require("./file_store");
const logger_1 = require("./logger");
const idb_store_1 = require("./idb_store");
const log_1 = require("./log");
const utils_1 = require("./utils");
const web_console_1 = require("./web_console");
class WebLogger extends logger_1.BaseLogger {
    constructor(loglevel = logger_1.LogLevel.Debug, configs, callback) {
        configs = (0, utils_1.trueAssign)(configs_1.DefaultConfigs, configs);
        super(new web_console_1.WebConsole(), loglevel, getStore(configs), configs, callback);
    }
    static getInstance(loglevel = logger_1.LogLevel.Debug, configs, callback) {
        if (!WebLogger._instance) {
            WebLogger._instance = new WebLogger(loglevel, configs, callback);
        }
        return WebLogger._instance;
    }
}
exports.WebLogger = WebLogger;
function getStore(configs) {
    if (configs.store !== "idb" &&
        "storage" in navigator &&
        "getDirectory" in navigator.storage) {
        (0, log_1.debug)("init file store");
        return file_store_1.FileStore.getInstance({
            expireDay: 2,
            maxFileSize: configs.maxFileSize,
        });
    }
    else {
        (0, log_1.debug)("init idb store");
        return idb_store_1.IdbStore.getInstance("gol", {
            expireTime: configs.expireTime,
            maxCount: configs.maxCount,
        });
    }
}
